export const getAvailabilitySectionClass = () => 'js-ao-tour-availability';

export const getAvailabilityDeparturesSectionClass = () => 'ao-tour-availability__departures';
